var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSortMini(_ref, svgRef) {
  let title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_104558",
    "data-name": "Group 104558",
    transform: "translate(-477 -520)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_104445",
    "data-name": "Group 104445",
    transform: "translate(22413 14665)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9388",
    "data-name": "Ellipse 9388",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(-21936 -14145)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9390",
    "data-name": "Ellipse 9390",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(-21936 -14139)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9392",
    "data-name": "Ellipse 9392",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(-21936 -14133)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9389",
    "data-name": "Ellipse 9389",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(-21930 -14145)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9391",
    "data-name": "Ellipse 9391",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(-21930 -14139)",
    fill: "silver"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9393",
    "data-name": "Ellipse 9393",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(-21930 -14133)",
    fill: "silver"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortMini);
export default __webpack_public_path__ + "static/media/SortMini.b374d6f72383ac794137e6e5d8fc07db.svg";
export { ForwardRef as ReactComponent };